import React from 'react';
import ReactDOM from 'react-dom';
import AppRoot from "./core/ui/Layouts/AppRoot";
import './i18n';

ReactDOM.render(<AppRoot />, document.getElementById('root'));
